import { MessageBus } from './MessageBus'
export type { MessageToken } from './MessageBus'

export const messageBus = new MessageBus();
